// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://buxzdtznczzvgcoiqwey.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ1eHpkdHpuY3p6dmdjb2lxd2V5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc4NzU0MzMsImV4cCI6MjA3MzQ1MTQzM30.kawiNV6RjwfQinPvk3pfATdo5tsaDntz06-gQUqW-bQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});